import { Injectable } from '@angular/core';

@Injectable()

export class apiUrlComponent {

     //Local SV01===============================
       public urlpath = 'http://localhost:3000/';

    //=== SV 03======================================
      //public urlpath = 'http://celldesupporttool-api.product.veridic.local/';

    //===========UAT Staging=======================================
      //public urlpath = 'https://stagingcelldesupporttool-api.cellde.com/';

}
